/* global Typed */

angular
    .module('WizApp')
    .factory('TypingService', [
        function () {
            return {
                /**
                 * @param destSelector string
                 * @param sentencesSelector string
                 * @param options array
                 *
                 * Options list : https://github.com/mattboldt/typed.js/#customization
                 */
                start: (destSelector, sentencesSelector, options = {}) => {
                    // Rewriting default parameters
                    let typingParams = {
                        strings: [],
                        stringsElement: sentencesSelector,
                        typeSpeed: options.hasOwnProperty('typeSpeed') ? options.typeSpeed : 100,
                        startDelay: options.hasOwnProperty('startDelay') ? options.startDelay : 0,
                        backSpeed: options.hasOwnProperty('backSpeed') ? options.backSpeed : 100,
                        smartBackspace: options.hasOwnProperty('smartBackspace') ? options.smartBackspace : true,
                        shuffle: options.hasOwnProperty('shuffle') ? options.shuffle : false,
                        backDelay: options.hasOwnProperty('backDelay') ? options.backDelay : 700,
                        fadeOut: options.hasOwnProperty('fadeOut') ? options.fadeOut : false,
                        fadeOutClass: options.hasOwnProperty('fadeOutClass') ? options.fadeOutClass : '',
                        fadeOutDelay: options.hasOwnProperty('fadeOutDelay') ? options.fadeOutDelay : 500,
                        loop: options.hasOwnProperty('loop') ? options.loop : true,
                        loopCount: options.hasOwnProperty('loopCount') ? options.loopCount : Infinity,
                        showCursor: options.hasOwnProperty('showCursor') ? options.showCursor : true,
                        cursorChar: options.hasOwnProperty('cursorChar') ? options.cursorChar : '|',
                        autoInsertCss: options.hasOwnProperty('autoInsertCss') ? options.autoInsertCss : true,
                        attr: options.hasOwnProperty('attr') ? options.attr : null,
                        bindInputFocusEvents: options.hasOwnProperty('bindInputFocusEvents') ? options.bindInputFocusEvents : false,
                        contentType: 'html',

                        onComplete: options.hasOwnProperty('onComplete') ? options.onComplete : () => {},
                        preStringTyped: options.hasOwnProperty('preStringTyped') ? options.preStringTyped : () => {},
                        onStringTyped: options.hasOwnProperty('onStringTyped') ? options.onStringTyped : () => {},
                        onLastStringBackspaced: options.hasOwnProperty('onLastStringBackspaced')
                            ? options.onLastStringBackspaced
                            : () => {},
                        onTypingPaused: options.hasOwnProperty('onTypingPaused') ? options.onTypingPaused : () => {},
                        onTypingResumed: options.hasOwnProperty('onTypingResumed') ? options.onTypingResumed : () => {},
                        onReset: options.hasOwnProperty('onReset') ? options.onReset : () => {},
                        onStop: options.hasOwnProperty('onStop') ? options.onStop : () => {},
                        onStart: options.hasOwnProperty('onStart') ? options.onStart : () => {},
                        onDestroy: options.hasOwnProperty('onDestroy') ? options.onDestroy : () => {}
                    };

                    return new Typed(destSelector, typingParams);
                }
            };
        }
    ]);
